(function () {
    'use strict';

    angular
        .module('franchisee.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, PATHS_FRANCHISEE, SYSTEM_MODULES) {
        $stateProvider
            .state('app.company-edit', {
                title: 'Minha Empresa',
                url: '/my-company',
                templateUrl: `${PATHS_FRANCHISEE.PHYSICAL}/components/companies/my-company-form.html`,
                controller: 'CompanyFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISEE_UNIT
            })
            .state('app.applications-list', {
                title: 'Aplicações',
                url: '/my-applications',
                templateUrl: `${PATHS_FRANCHISEE.PHYSICAL}/components/applications/applications.html`,
                controller: 'ApplicationsListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISEE_APPLICATION
            })

            //PEOPLE
            .state('app.people-list', {
                title: 'Buscar Pessoas',
                url: '/people',
                templateUrl: `${PATHS_FRANCHISEE.PHYSICAL}/components/people/people-list.html`,
                controller: 'PeopleListController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISEE_PEOPLE
            })
            .state('app.people-associate', {
                title: 'Associar Pessoa',
                url: '/people/associate',
                templateUrl: `${PATHS_FRANCHISEE.PHYSICAL}/components/people/people-associate.html`,
                controller: 'PeopleAssociateController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISEE_PEOPLE
            })
            .state('app.people-edit', {
                title: 'Visualizar Pessoa',
                url: '/people/{personId:int}',
                templateUrl: `${PATHS_FRANCHISEE.PHYSICAL}/components/people/people-form.html`,
                controller: 'PeopleFormController',
                controllerAs: 'vm',
                moduleId: SYSTEM_MODULES.FRANCHISEE_PEOPLE
            })
    }
}());